import {
  useQuery,
  useMutation,
  useQueryClient,
  keepPreviousData,
} from "@tanstack/react-query";
import { locationService } from "../services/svc_locations";
import { queryKeys } from "../lib/queryKeys";
import { ListRequest } from "../types/common/commonTypes";

export const useTSQLocationList = (
  params: ListRequest,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: queryKeys.location.list(params),
    queryFn: () => locationService.list(params),
    placeholderData: keepPreviousData,
    enabled: enabled,
  });
};

export const useTSQLocation = (id: string) => {
  return useQuery({
    queryKey: queryKeys.location.detail(id),
    queryFn: () => locationService.getById(id),
    enabled: !!id,
  });
};

export const useTSMCreateLocation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: locationService.create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.location.lists() });
    },
    onError: (error) => {
      console.error("Failed to create Location:", error);
    },
  });
};

export const useTSMUpdateLocation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: any }) =>
      locationService.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.location.lists() });
    },
    onError: (error) => {
      console.error("Failed to create Location:", error);
    },
  });
};

export const useTSMDeactivateLocation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: locationService.deactivate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.location.lists() });
    },
    onError: (error) => {
      console.error("Failed to deactivate Location:", error);
    },
  });
};

export const useTSMReactivateLocation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: locationService.reactivate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.location.lists() });
    },
    onError: (error) => {
      console.error("Failed to reactivate Location:", error);
    },
  });
};
